/**
 * A regex object to validate phone numbers
 */
export const PHONE_NUMBER_REGEX = /^(?:[\+0]?\d[\s-]?)?(?:(?:\(\d{3}\)[\s-]?)|(?:\d{3})[\s-]?)?\d{3}[\s\-]?\d{4}$/;

/*
Handles the following cases

1234567
123-4567
5551234567
555-123-4567
(555) 123-4567
15551234567
1-555-123-4567
1 555 123-4567
1 (555) 123-4567
+1 (555) 123-4567
01 (555) 123-4567
*/
